import { add } from '../../products/services/ProductsService';
import { generateProductName } from './nameGenerators';
import { ProductStatus } from '../../products/types';

const statuses = [ProductStatus.Active, ProductStatus.Draft, ProductStatus.Deprecated];
const statusWeights = [0.7, 0.2, 0.1]; // 70% Active, 20% Draft, 10% Deprecated

const shortDescriptions = [
  'Streamline your workflow with powerful features',
  'Boost productivity with advanced automation',
  'Transform your business operations',
  'Enhance collaboration and efficiency',
  'Optimize performance with intelligent insights',
  'Simplify complex processes',
  'Accelerate growth with data-driven solutions'
];

const longDescriptionTemplates = [
  'is a comprehensive SaaS solution designed to enhance productivity and drive business growth. Features include real-time collaboration, advanced analytics, and seamless integrations.',
  'provides enterprise-grade functionality with intuitive user experience. Built for scalability and performance, it offers robust security and extensive customization options.',
  'delivers cutting-edge technology to streamline operations and maximize efficiency. With powerful automation and intelligent workflows, it transforms how teams work.',
  'combines innovative features with proven reliability to accelerate business outcomes. Designed for modern enterprises, it offers flexible deployment and comprehensive support.'
];

const getRandomStatus = () => {
  const random = Math.random();
  let cumulative = 0;
  for (let i = 0; i < statusWeights.length; i++) {
    cumulative += statusWeights[i];
    if (random < cumulative) {
      return statuses[i];
    }
  }
  return statuses[0];
};

const generateProductData = () => {
  const name = generateProductName();
  const shortDesc = shortDescriptions[Math.floor(Math.random() * shortDescriptions.length)];
  const longDesc = longDescriptionTemplates[Math.floor(Math.random() * longDescriptionTemplates.length)];
  
  return {
    name,
    shortDescription: `${name} - ${shortDesc}`,
    longDescription: `${name} ${longDesc}`,
    status: getRandomStatus(),
    freeTrial: Math.random() < 0.7 // 70% chance of free trial
  };
};

export const generateProductsTestData = async (count: number) => {
  const promises = [];
  
  for (let i = 1; i <= count; i++) {
    const productData = generateProductData();
    promises.push(add(productData));
  }
  
  try {
    const results = await Promise.all(promises);
    console.log(`Generated ${count} test products`);
    return results.filter(Boolean);
  } catch (error) {
    console.error('Error generating product test data:', error);
    return [];
  }
};